export default "__VITE_ASSET__BffnOoww__"